import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/navlayer/view/navlayer.view.query.gql"
import type {
  NavLayerViewQuery,
  NavLayerViewQueryVariables,
} from "@/v2-backoffice-client/navlayer/view/__types__/navlayer.view.query"

type Options = QueryHookOptions<NavLayerViewQuery, NavLayerViewQueryVariables>

export function useNavLayerViewQuery(options?: Options) {
  return useQuery<NavLayerViewQuery, NavLayerViewQueryVariables>(query, options)
}
